import axios from 'axios';
import { API_BASE_URL } from './constants';

const client = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000
});

// Not: İl/ilçe listesi ve başvuru dönemi uygulama içine gömülüdür (src/data, src/constants).
// Sunucuya yalnızca kullanıcının tetiklediği iki işlemde istek atılır.

export const submitBasvuru = (payload) => client.post('/basvuru', payload).then(r => r.data);

export const sorgulaBasvuru = (payload) => client.post('/sorgula', payload).then(r => r.data);

export default client;
